
import * as pbi from 'powerbi-client';
import { FilterGD, SourcePowerBIEnum } from 'src/app/interfaces/models/filter-item.model';
import { FiltersGeneralDashboardModel } from 'src/app/interfaces/models/filters-general-dashboard.model';
import { Data } from 'src/app/interfaces/Responses/IPBITokenInfoResponse';
import { SharedService } from 'src/app/services/dashboards/shared.service';
import { environment } from 'src/environments/environment';

import { HttpErrorResponse } from '@angular/common/http';


import { DOCUMENT } from '@angular/common';
import { AfterContentChecked, AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, inject, Inject, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';

import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDrawer, MatDrawerContainer } from '@angular/material/sidenav';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { stat } from 'fs';

import { Incidents } from 'src/app/domain/incidents.model';
import { IncidentStatus } from 'src/app/domain/incidentStatus.model';
import { incidentType } from 'src/app/domain/incidentType.model';
import { Site } from 'src/app/domain/site.model';



import { ControltowerService } from 'src/app/services/dashboards/controltower.service';

import { MatDialog as MatDialog } from '@angular/material/dialog';
import { RejectIncidentsComponent } from './detail-health-safety-control-tower-dashboard/reject-incidents/reject-incidents.component';
import { GridColumnsConfiguration, GridFilter, IconColumn } from '../../shared/grid/grid.component';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatOption as MatOption } from '@angular/material/core';
import Chart from 'chart.js/auto'
import { IIncidentsResponse } from 'src/app/interfaces/Responses/IIncidentsResponse';
import { IIncidentTypeResponse } from 'src/app/interfaces/Responses/IIncidentsTypesResponse';
import { IIncidentsStatusResponse } from 'src/app/interfaces/Responses/IIncidentsStatusResponse';
import { ISitesResponse } from 'src/app/interfaces/Responses/ISitesResponse';
import { Subscription } from 'rxjs';
import { SiteDto } from 'src/app/interfaces/Dtos/site.dto';
import { IncidentTypeDto } from 'src/app/interfaces/Dtos/incident-type.dto';
import { TranslateService } from '@ngx-translate/core';
import { IncidentByEventIdFilterDto, IncidentFilterDto } from 'src/app/interfaces/Dtos/IncidentFilter.dto';
import { closeModalEventData } from 'src/app/domain/incidentRecord.model';
import { ControlTowerModalService } from 'src/app/services/shared/control-tower-modal.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSelect as MatSelect } from '@angular/material/select';
import { PropertiesTowers } from 'src/app/services/dashboards/propertiesTower.service';
import * as _ from 'lodash'
import { ActivatedRoute, Params } from '@angular/router';
import { LoginService } from 'src/app/services/security/login.service';
import { EventsService } from 'src/app/services/dashboards/events.service';
import { map } from 'rxjs/operators';
import { HttpTransportType, HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { Notifications } from 'src/app/services/shared/notifications.service';
import * as signalR from '@microsoft/signalr'
import { GridServiceService } from 'src/app/services/shared/grid-service.service';
import { UpdateGridRowDto } from 'src/app/interfaces/Dtos/grid-data.dto';
import { get } from 'http';
import { MatChipInputEvent } from '@angular/material/chips';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { COMMA, ENTER } from '@angular/cdk/keycodes';

export interface UsuariosData {
  nombre: string,
  apellidop: string,
  apellidom: string
}


@Component({
  selector: 'neoris-health-safety-control-tower-dashboard',
  templateUrl: './health-safety-control-tower-dashboard.component.html',
  styleUrls: ['./health-safety-control-tower-dashboard.component.css'],
})

export class HealthSafetyControlTowerDashboardComponent implements OnInit, AfterViewChecked, OnDestroy {
 readonly keywords = signal([]);
announcer = inject(LiveAnnouncer);
readonly separatorKeysCodes = [ENTER, COMMA] as const;
  readonly addOnBlur = true;

removeKeyword(keyword: string) {
    this.keywords.update(keywords => {
      const index = keywords.indexOf(keyword);
      if (index < 0) {
        return keywords;
      }

      keywords.splice(index, 1);
      this.announcer.announce(`removed ${keyword}`);
      return [...keywords];
    });
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our keyword
    if (value) {
      this.keywords.update(keywords => [...keywords, value]);
    }

    // Clear the input value
    event.chipInput!.clear();
  }






  public showNotifications = true;
  notifications: { id: number, content: string, hidden: boolean }[] = [];

  public hideMessageArea: boolean = false
  public isModalOpen: boolean = false
  public hideAreaMessage() {

    this.newNotifications = false;


    this.hideMessageArea = !this.hideMessageArea;
  }














  private connection: HubConnection;

  readonly eventTypesAllowed = [35, 36, 38, 39, 41]
  public gridColumnsConfiguration: GridColumnsConfiguration = {
    IconValue: "incidentStatusId",
    IconColumnName: "incidentStatus",
    hiddenColumnNames: ['eventId',
      'siteId',
      'incidentTypeId',
      'severityId',
      'incidentStatusId',
      'typeOfOmissionId',
      'categoryId',
      'positionId',
      'typeOfStaffId',
      'incidentAreaId',
      'rootCauseId',
      'imagesURL',
      'consequencesSystemId',
      'rejectedReasonId',
      'isNew',
      "ROW_ID"
    ],
    dateColumns: [
      { columnName: 'occurred' },
      { columnName: 'registrationDate' },
      { columnName: 'closingDate' },
      { columnName: 'dueDate' }
    ],
    cardColum: "occurred",
    cardValues: [
      { place: 0, nombre: 'occurred', isMainColumn: false },
      { place: 0, nombre: 'site', isMainColumn: false },
      { place: 0, nombre: 'incidentArea', isMainColumn: false },
      { place: 0, nombre: 'incidentType', isMainColumn: false },
      { place: 0, nombre: 'safetyItems', isMainColumn: false },
      { place: 0, nombre: 'incidentStatus', isMainColumn: true }
    ],
    listColumns: [
      'site',
      'incidentArea',
      'category',
      'rootCause',
      'rejectedReason',
      'incidentType',
      'severity',
      'incidentStatus',
      'monitoringAdvisor',
      'position',
      'typeOfStaff',
      'autoStatusType',
      'autoRejectionReasonType',
      'eventDescription',
      'consequencesSystem'
      // 'incidentArea',
      // 'descripcion'

    ],
    MultiIconColumns: [
      {
        columnName: 'safetyItems', 
        propertyName: 'value', 
         icons: [
          {
            value: "32-1",
            iconUrl: "assets/images/controlTowers/helmet_ok.svg",
          },
          {
            value: "33-1",
            iconUrl: "assets/images/controlTowers/safety_vest_ok.svg",
          },
          {
            value: "34-1",
            iconUrl: "assets/images/controlTowers/gloves_ok.svg",
          },
          {
            value: "35-1",
            iconUrl: "assets/images/controlTowers/glases_ok.svg",
          },
          {
            value: "58-1",
            iconUrl: "assets/images/controlTowers/nomex_ok.svg",
          },
          {
            value: "32-0",
            iconUrl: "assets/images/controlTowers/helmet_no.svg",
          },
          {
            value: "33-0",
            iconUrl: "assets/images/controlTowers/safety_vest_no.svg",
          },
          {
            value: "34-0",
            iconUrl: "assets/images/controlTowers/gloves_no.svg",
          },
          {
            value: "35-0",
            iconUrl: "assets/images/controlTowers/glases_no.svg",
          },
          {
            value: "58-0",
            iconUrl: "assets/images/controlTowers/nomex_no.svg",
          }
        ]
      },
    ],
    ActionColumn: {
      ColumnName: "",
      Actions: [
      ]
    }
  }

  private lang: string = "en";
  public activeFilter: number = -1;
  today = new Date();
  month = this.today.getUTCMonth();
  year = this.today.getUTCFullYear();
  day = this.today.getUTCDate()

  private new_Date = new Date()
  public _showModal: boolean = false;

  public minGridColumns: string[] = ['incidentStatus']
  public gFilter: GridFilter[] = [];

  public incidentRecordData: any


  disableSelect = new UntypedFormControl(false);

  displayedColumns: string[] = ['id', 'nombre', 'apellido', 'usuario', 'password', "status"]
  gridTitle: string = "SAFETY_INCIDENTS_ALERTS"

  public screenHeight: number;
  desktopView: MediaQueryList = matchMedia('(min-width: 1280px)')
  _site: string;
  currentFormat: string = '1'
  descargado: boolean = false
  type: string

  dashboardTypeId: string = '1105'

  businessUnitId: string = '1'
  lastUpdate: string
  report: any
  filtersGeneralDashboardModel: FiltersGeneralDashboardModel

  arrayGirdControlTower: any[] = []
  arrayCountResults: any[] = [5, 10, 15, 20]
  arraySites: any[] = []
  arrayIncidentsTypes: any[] = []
  arrayIncidentStatus: IncidentStatus[] = []
  arrayIncidentTypesMonitoring: any[] = []
  modelIncident: Incidents = { eventTypes: [], data: [] }
  private onIsAllSitesSubscription: Subscription
  private onFiltersParams: Subscription
  private moveRowSubscription: Subscription
  showFiller = false;
  @ViewChild('drawer') drawer: MatDrawer;

  public filters = new UntypedFormGroup({
    site: new UntypedFormControl(''),
    incidentType: new UntypedFormControl(''),
    start: new UntypedFormControl(new Date(this.year, this.month, this.day)),
    end: new UntypedFormControl(new Date(this.year, this.month, this.day + 1)),
    status: new UntypedFormControl(''),
    visualSearch: new UntypedFormControl(''),
    incidentResults: new UntypedFormControl(5),
  });

  private onLanChange: Subscription
  private refreshGridObservable: Subscription

  private eventIdQueryParam: number = undefined

  private startDateChageSubscription: Subscription
  public _clearFilters: boolean = false
  constructor(private sharedService: SharedService,
    private controltowerservice: ControltowerService,
    private translate: TranslateService,
    private controlTowerModalService: ControlTowerModalService,
    private _snackBar: MatSnackBar,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private gridService: GridServiceService,
    private propertiesService: PropertiesTowers,
    private rutaActiva: ActivatedRoute,
    private securityService: LoginService,
    private notificationsService: Notifications,
    @Inject(DOCUMENT) private document: Document) {

    this.onLanChange = this.translate.onLangChange.subscribe(s => {
      this.lang = s.lang
      this.getIncidendsByFilters()
    })


    this.refreshGridObservable = this.controlTowerModalService.refreshGridObservable.subscribe(refreshAction => {

      console.log("refreshGridObservable", refreshAction)

      switch (refreshAction.operation) {
        case 'accept-incident':
          // this.getIncidendsByFilters()
          this.RefreshOneRecordGrid(refreshAction.object, 'update')
          break;
        case 'reasonSendMessage':
          this.RefreshOneRecordGrid(refreshAction.object, 'update')
          break;
        default:
          this.getIncidendsByFilters()
          break;
      }

    })
  }

  @ViewChild('selSite') selSite: MatSelect;
  @ViewChild('selIncidentType') selIncidentType: MatSelect;
  @ViewChild('selStatus') selStatus: MatSelect;

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();

  }

  async ngOnInit(): Promise<void> {

    this.notificationsService.ShowNotifications(true)
    const userName = JSON.parse(localStorage.getItem('ud'))[1].value
    const guid = JSON.parse(localStorage.getItem('guidSession'))
    const response = await this.securityService.login(userName, guid).toPromise()

    this.rutaActiva.queryParamMap.subscribe(queryParams => {
      const eventIdQueryParam = queryParams.get('ei');
      this.eventIdQueryParam = eventIdQueryParam ? parseInt(eventIdQueryParam) : undefined

      this.LoadByEventId = this.eventIdQueryParam !== undefined
    });

    this.arrayIncidentTypesMonitoring = []
    this.propertiesService.clearPropertiesData()

    this.onIsAllSitesSubscription = this.propertiesService.IsSelectAllSites$.subscribe((value) => {
      this.getFiltersAndIncidents()
    })

    this.onFiltersParams = this.propertiesService.filtersParams$.subscribe((value) => {

      if (value != null || value != undefined) {
        this.arrayIncidentTypesMonitoring = value.incidentsTypes
        this.filters.controls['start'].setValue(value.startDate)
        this.filters.controls['end'].setValue(value.endDate)
      }


    })

    this.moveRowSubscription = this.gridService.emitMoveRowDataObservable.subscribe((data) => {


      console.log("data", data)
      this.incidentRecordData = undefined
      this.incidentRecordData = data
      localStorage.setItem('rowSelectEvent', JSON.stringify(data))

    })





  }





  private _hubConnection: signalR.HubConnection



  public newNotifications: boolean = false




  getMaxEventId(): number {
    if (this.arrayGirdControlTower.length === 0) {
      return 0;
    }

    return this.arrayGirdControlTower.reduce((max, record) => {
      return record.eventId > max ? record.eventId : max;
    }, this.arrayGirdControlTower[0].eventId);
  }

  onDatepickerClosed(): void {

    var today = new Date();
    today.setMonth(today.getMonth() - 1);

    var startDate = this.filters.get('start').value

    if (startDate < today) {
      today = startDate
      this.getIncidentsTypes(today)
    }

  }


  private async getFiltersAndIncidents() {
    const filtersInfoRetrieved: boolean = await this.getFilters()
    if (filtersInfoRetrieved) {
      await this.setDefaultFilters()
    }

  }

  ngOnDestroy(): void {
    this.notificationsService.ShowNotifications(false)
    this.onLanChange.unsubscribe()
    this.refreshGridObservable.unsubscribe()
    this.onIsAllSitesSubscription.unsubscribe()
    this.onFiltersParams.unsubscribe()
    this.propertiesService.clearPropertiesDataFilters()
    this.moveRowSubscription.unsubscribe()

  }




  private setDefaultIncidentTypes() {

    console.log("this.arrayIncidentTypesMonitoring.", this.arrayIncidentTypesMonitoring)
    if (this.arrayIncidentTypesMonitoring.length > 0) {
      if (this.arrayIncidentsTypes.length > 0) {
        this.selIncidentType.options.forEach(f => {
          for (let i = 0; i <= this.arrayIncidentTypesMonitoring.length - 1; i++) {

            if (f.value.id == this.arrayIncidentTypesMonitoring[i]) {

              f.select()
            }
          }

        })
      }
    }
    else {
      if (this.arrayIncidentsTypes.length > 0) {
        this.selIncidentType.options.forEach(f => {

          if (f.value.isSelected == true) {
            f.select()
          }
        })
      }
    }
  }

  private async setDefaultFilters() {

    this.setDefaultIncidentTypes();

    if (this.arrayIncidentStatus.length > 0) {

      if (this.LoadByEventId == false) {
        const selectedStatus = this.arrayIncidentStatus.filter(f => f.id == 10000 || f.id == 10001)
        this.filters.get('status').setValue(selectedStatus)
      } else {
        const selectedStatus = this.arrayIncidentStatus
        this.filters.get('status').setValue(selectedStatus)
      }
    }

    if (this.LoadByEventId == false) {
      await this.getIncidendsByFilters()
    } else {
      console.log("INCIDENT BY EVENT IDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD")
      await this.getIncidendsByEventId()
    }
  }

  private LoadByEventId = false;

  async getFilters() {

    var today = new Date();
    today.setMonth(today.getMonth() - 1);

    let successIncidentsTypes = await this.getIncidentsTypes(today)
    let successIncidentStatus = await this.getncidentStatus()

    if (successIncidentsTypes && successIncidentStatus) {
      return true;
    }
    else {
      return false
    }
  }

  async searchButtonClick() {
    await this.getIncidendsByFilters()
  }

  private clearCardFilters() {
    this.activeFilter = -1
    this.filterGridFromCardSelected(this.activeFilter)
  }

  private async getIncidendsByFilters() {

    this.clearCardFilters()

    let checkedSites: SiteDto[] = [{ id: Number.parseInt(localStorage.getItem('site')), name: '' }]
    let checkedIncidentsType: IncidentTypeDto[] = this.filters.get('incidentType').value
    let checkedIncidentsStatus: IncidentStatus[] = this.filters.get('status').value
    const startDate: Date = this.filters.get('start').value
    const endDate: Date = this.filters.get('end').value

    let search: boolean = true;

    if (checkedSites.length == 0) {
      search = false;
    }

    if (checkedIncidentsType.length == 0) {
      search = false;
    }

    if (checkedIncidentsStatus.length == 0) {
      search = false;
    }

    if (search == true) {
      let filters: IncidentFilterDto = {
        eventTypesId: [],
        locale_code: this.lang,
        sitesId: [],
        incidentsTypes: [],
        startDate: startDate,
        endDate: endDate,
        statusesId: [],
        visualSearchPrompts: [],
        responseLimits: 0
      }

      checkedSites.forEach(site => {
        if (site.id !== undefined) {
          filters.sitesId.push(site.id)
        }
      })
      checkedIncidentsType.forEach(incidentType => {
        if (incidentType.id !== undefined) {
          filters.incidentsTypes.push(incidentType.id)
          filters.eventTypesId.push(incidentType.id)
        }
      })
      checkedIncidentsStatus.forEach(status => {

        if (status.id !== undefined) {
          filters.statusesId.push({
            statusId: status.id,
            attributeTypeId: status.attributeTypeId
          })
        }
      })


      //Visual search
      var keywords = this.keywords();
      var limitResults = this.filters.get('incidentResults').value

      if (keywords.length > 0) {
        filters.visualSearchPrompts = keywords
      }

      filters.responseLimits = limitResults
      

      let successIncidents = await this.getIncidents(filters)



    } else {
      const WARNING_FILTER_INCIDENT_SEARCH = this.translate.instant('WARNING_FILTER_INCIDENT_SEARCH')
      this.openSnackBar(WARNING_FILTER_INCIDENT_SEARCH, 'Warning')
    }
  }

  private async getIncidendsByEventId() {


    this.clearCardFilters()

    let checkedSites: SiteDto[] = [{ id: Number.parseInt(localStorage.getItem('site')), name: '' }]
    let checkedIncidentsType: IncidentTypeDto[] = this.filters.get('incidentType').value
    let checkedIncidentsStatus: IncidentStatus[] = this.filters.get('status').value
    const startDate: Date = this.filters.get('start').value
    const endDate: Date = this.filters.get('end').value

    let search: boolean = true;

    if (checkedSites.length == 0) {
      search = false;
    }

    if (checkedIncidentsType.length == 0) {
      search = false;
    }

    if (checkedIncidentsStatus.length == 0) {
      search = false;
    }

    if (search == true) {
      let filters: IncidentByEventIdFilterDto = {
        eventTypesId: [35, 36, 38, 39, 41, 48],
        locale_code: this.lang,
        sitesId: [],
        incidentsTypes: [],
        eventId: this.eventIdQueryParam,
        statusesId: []
      }

      checkedSites.forEach(site => {
        if (site.id !== undefined) {
          filters.sitesId.push(site.id)
        }
      })
      checkedIncidentsType.forEach(incidentType => {
        if (incidentType.id !== undefined) {
          filters.incidentsTypes.push(incidentType.id)
        }
      })
      checkedIncidentsStatus.forEach(status => {
        if (status.id !== undefined) {
          filters.statusesId.push(status.id)
        }
      })

      let successIncidents = await this.getIncidentsByEventId(filters)
    } else {
      const WARNING_FILTER_INCIDENT_SEARCH = this.translate.instant('WARNING_FILTER_INCIDENT_SEARCH')
      this.openSnackBar(WARNING_FILTER_INCIDENT_SEARCH, 'Warning')
    }
  }

  openSnackBar(message: string, action: string) {
    if (action == 'OK') {
      this._snackBar.open(message, action, {
        duration: 5000,
        panelClass: ['blue-snackbar']
      });
    }
    else {
      this._snackBar.open(message, action, {
        duration: 5000,
        panelClass: ['blue-snackbar-false']
      });
    }
  }

  RenderChart(helmet: number, vest: number) {

    const data = [
      { id: "Helmet", value: helmet },
      { id: "Vest", value: vest },
      { id: "ppe", value: helmet },
      { id: "da", value: vest }
    ];



    Chart.defaults.layout.padding = 20;

    Chart.defaults.plugins.legend.display = false;
    Chart.defaults.plugins.legend.maxHeight = 70
    Chart.defaults.plugins.legend.labels.boxWidth = 40
    Chart.defaults.plugins.legend.labels.usePointStyle = true
    Chart.defaults.plugins.legend.align = "start"

    Chart.defaults.plugins.decimation.enabled = true


    Chart.defaults.plugins.tooltip.callbacks.label = function (context) {
      let label = context.dataset.label || '';
      if (label) {
        label += ': ';
      }
      label += context.parsed + " %"
      return label;
    }



    const chart = new Chart("piechart", {
      type: 'pie',
      data: {
        labels: data.map(row => row.id),
        datasets: [
          {
            label: ' ',
            data: data.map(row => row.value),
            backgroundColor: [
              '#006CC4',
              '#0E1A77'
            ]
          }
        ]
      }
    }
    );
  }

  formatDate(date: Date): string {
    let new_Date = new Date(date)
    const day = new_Date.getUTCDate()
    const month = new_Date.getUTCMonth() + 1
    const year = new_Date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  }

  private getTime(date?: Date) {
    return date != null ? date.getTime() : 0;
  }


  private  SetIncidentsInfo(incident: any){
    let arrayGirdControlTowerPush: any[] = []

    this.modelIncident = incident

    let arrayEventsId: number[] = []


    this.modelIncident.data.forEach(incidentRecord => {

      arrayEventsId.push(incidentRecord.eventId)

      const { id: typeOfOmissionId, name: typeOfOmission } = incidentRecord.typeOfOmission == undefined ? { id: null, name: "" } : incidentRecord.typeOfOmission
      const { id: categoryId, name: category } = incidentRecord.category == undefined ? { id: null, name: "" } : incidentRecord.category
      const { id: positionId, name: position } = incidentRecord.position == undefined ? { id: null, name: "" } : incidentRecord.position
      const { id: typeOfStaffId, name: typeOfStaff } = incidentRecord.typeOfStaff == undefined ? { id: null, name: "" } : incidentRecord.typeOfStaff
      const { id: incidentAreaId, name: incidentArea } = incidentRecord.incidentArea == undefined ? { id: null, name: "" } : incidentRecord.incidentArea
      const { id: rootCauseId, name: rootCause } = incidentRecord.rootCause == undefined ? { id: null, name: "" } : incidentRecord.rootCause
      const { id: consequencesSystemId, name: consequencesSystem } = incidentRecord.consequencesSystem == undefined ? { id: null, name: "" } : incidentRecord.consequencesSystem
      let { id: rejectedReasonId, name: rejectedReason } = incidentRecord.reasonRejection == undefined ? { id: null, name: "" } : incidentRecord.reasonRejection

      let { id: autoStatusTypeId, name: autoStatusType } = incidentRecord.autoStatusType == undefined ? { id: null, name: "" } : incidentRecord.autoStatusType
      let { id: autoRejectionReasonTypeId, name: autoRejectionReasonType } = incidentRecord.autoRejectionReasonType == undefined ? { id: null, name: "" } : incidentRecord.autoRejectionReasonType

      arrayGirdControlTowerPush.push({
        ROW_ID: incidentRecord.eventId,
        isNew: false,
        occurred: incidentRecord.occurred,
        incidentArea: incidentArea,
        incidentType: incidentRecord.incidentType.name,
        safetyItems: (incidentRecord.objectAttributes ?? []).filter(f => [32, 33, 34, 35, 58].includes(f.attributeTypeId)).map(m =>  m.value = { value: `${m.attributeTypeId}-${m.valueStr}` }),
        severity: incidentRecord.severity.name,
        incidentStatus: incidentRecord.incidentStatus.name,
        rejectedReason: rejectedReason,
        descripcion: incidentRecord.descripcion,
        monitoringAdvisor: incidentRecord.monitoringAdvisor,
        actionTaken: incidentRecord.actionTaken,
        eventId: incidentRecord.eventId,
        incidentTypeId: incidentRecord.incidentType.id,
        severityId: incidentRecord.severity.id,
        incidentStatusId: incidentRecord.incidentStatus.id,
        typeOfOmissionId: typeOfOmissionId,
        typeOfOmission: typeOfOmission,
        categoryId: categoryId,
        category: category,
        invoice: incidentRecord.invoice,
        address: incidentRecord.address,
        registrationDate: incidentRecord.registrationDate,
        closingDate: incidentRecord.closingDate,
        numberOfDays: incidentRecord.numberOfDays,
        personName: incidentRecord.personName,
        positionId: positionId,
        position: position,
        typeOfStaffId: typeOfStaffId,
        typeOfStaff: typeOfStaff,
        incidentAreaId: incidentAreaId,
        siteId: incidentRecord.site.id,
        site: incidentRecord.site.name,
        eventDescription: incidentRecord.eventDescription,
        imagesURL: incidentRecord.imagesURL,
        images: incidentRecord.images,
        rootCauseId: rootCauseId,
        rootCause: rootCause,
        consequencesSystemId: consequencesSystemId,
        consequencesSystem: consequencesSystem,
        headOfUN: incidentRecord.headOfUN,
        employeeNumber: incidentRecord.employeeNumber,
        dueDate: incidentRecord.dueDate,
        responsible: incidentRecord.responsible,
        rejectedReasonId: rejectedReasonId,
        autoStatusType: autoStatusType,
        autoRejectionReasonType: autoRejectionReasonType,
        embbedingPromptResponse: incidentRecord.embbedingPromptResponse,
      })
    });

    console.log("arrayGirdControlTowerPush", arrayGirdControlTowerPush)

    arrayGirdControlTowerPush.sort(function (a, b) {

      let aa = a.occurred;
      let bb = b.occurred;


      return aa > bb ? -1 : aa < bb ? 1 : 0
      return 0;
    });

    this.arrayGirdControlTower = arrayGirdControlTowerPush

    return arrayGirdControlTowerPush;

  }



  private async getIncidents(filters: IncidentFilterDto): Promise<boolean> {

    this.modelIncident = { eventTypes: [], data: [] }
    this.arrayGirdControlTower = []

    return new Promise<boolean>((resolve, reject) => {

      this.controltowerservice.getIncidents(filters).subscribe(
        {
          next: (incident: any) => {

           var arrayGirdControlTowerPush = this.SetIncidentsInfo(incident)

            if (this.eventIdQueryParam != undefined && this.LoadByEventId == true) {
              var event = arrayGirdControlTowerPush.find(f => f.eventId == this.eventIdQueryParam)

              console.log("event event event ", event)

              if (event !== undefined) {
                this.cellClick(event)
              }
            }

            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )

    });
  }

  //-------------------------------------------------------------------------------------------------------

  private RefreshOneRecordGrid(refresData: any, action: string) {
    // gridService
    // var eventId = refresData.eventId
    var eventId = this.incidentRecordData.eventId
    this.UpdateIncidentDataOnGridView(eventId, action)
  }

  private UpdateIncidentDataOnGridView(eventId, action) {

    let checkedSites: SiteDto[] = [{ id: Number.parseInt(localStorage.getItem('site')), name: '' }]
    let checkedIncidentsType: IncidentTypeDto[] = this.filters.get('incidentType').value
    let checkedIncidentsStatus: IncidentStatus[] = this.arrayIncidentStatus
    const startDate: Date = this.filters.get('start').value
    const endDate: Date = this.filters.get('end').value

    let filters: IncidentFilterDto = {
      eventTypesId: [],
      locale_code: this.lang,
      sitesId: [],
      incidentsTypes: [],
      startDate: startDate, //"2024-02-27 00:00:00" 
      endDate: endDate, //"2024-02-29 12:14:00"       
      statusesId: [],
      visualSearchPrompts: [],
      responseLimits: 0
    }

    checkedSites.forEach(site => {
      if (site.id !== undefined) {
        filters.sitesId.push(site.id)
      }
    })
    checkedIncidentsType.forEach(incidentType => {
      if (incidentType.id !== undefined) {
        filters.incidentsTypes.push(incidentType.id)
        filters.eventTypesId.push(incidentType.id)
      }
    })
    checkedIncidentsStatus.forEach(status => {
      if (status.id !== undefined) {
        filters.statusesId.push({
          statusId: status.id,
          attributeTypeId: 0
        })
      }
    })

      //Visual search
      var keywords = this.keywords();
      var limitResults = this.filters.get('incidentResults').value

      if (keywords.length > 0) {
        filters.visualSearchPrompts = keywords
      }

      filters.responseLimits = limitResults

    this.GetIncidentsAndThenRefreshItOnGrid(filters, eventId, action)
  }

  private async GetIncidentsAndThenRefreshItOnGrid(filters: IncidentFilterDto, eventId: any, action: string): Promise<boolean> {

    this.modelIncident = { eventTypes: [], data: [] }

    return new Promise<boolean>((resolve, reject) => {

      this.controltowerservice.getIncidents(filters).subscribe(
        {
          next: (incident: any) => {

            console.log("GET INCIDENTS", filters)

            this.modelIncident = incident

            if (incident.data.length > 0) {

              let arrayGirdControlTowerPush: any[] = []

              let arrayEventsId: number[] = []
              incident.data.forEach(incidentRecord => {

                arrayEventsId.push(incidentRecord.eventId)

                const { id: typeOfOmissionId, name: typeOfOmission } = incidentRecord.typeOfOmission == undefined ? { id: null, name: "" } : incidentRecord.typeOfOmission
                const { id: categoryId, name: category } = incidentRecord.category == undefined ? { id: null, name: "" } : incidentRecord.category
                const { id: positionId, name: position } = incidentRecord.position == undefined ? { id: null, name: "" } : incidentRecord.position
                const { id: typeOfStaffId, name: typeOfStaff } = incidentRecord.typeOfStaff == undefined ? { id: null, name: "" } : incidentRecord.typeOfStaff
                const { id: incidentAreaId, name: incidentArea } = incidentRecord.incidentArea == undefined ? { id: null, name: "" } : incidentRecord.incidentArea
                const { id: rootCauseId, name: rootCause } = incidentRecord.rootCause == undefined ? { id: null, name: "" } : incidentRecord.rootCause
                const { id: consequencesSystemId, name: consequencesSystem } = incidentRecord.consequencesSystem == undefined ? { id: null, name: "" } : incidentRecord.consequencesSystem
                let { id: rejectedReasonId, name: rejectedReason } = incidentRecord.reasonRejection == undefined ? { id: null, name: "" } : incidentRecord.reasonRejection



                arrayGirdControlTowerPush.push({
                  occurred: incidentRecord.occurred,
                  incidentArea: incidentArea,
                  incidentType: incidentRecord.incidentType.name,
                  safetyItems: (incidentRecord.objectAttributes ?? []).filter(f => [32, 33, 34, 35, 58].includes(f.attributeTypeId)).map(m =>  m.value = { value: `${m.attributeTypeId}-${m.valueStr}` }),
                  severity: incidentRecord.severity.name,
                  incidentStatus: incidentRecord.incidentStatus.name,
                  rejectedReason: rejectedReason,
                  descripcion: incidentRecord.descripcion,
                  monitoringAdvisor: incidentRecord.monitoringAdvisor,
                  actionTaken: incidentRecord.actionTaken,
                  eventId: incidentRecord.eventId,
                  incidentTypeId: incidentRecord.incidentType.id,
                  severityId: incidentRecord.severity.id,
                  incidentStatusId: incidentRecord.incidentStatus.id,
                  typeOfOmissionId: typeOfOmissionId,
                  typeOfOmission: typeOfOmission,
                  categoryId: categoryId,
                  category: category,
                  invoice: incidentRecord.invoice,
                  address: incidentRecord.address,
                  registrationDate: incidentRecord.registrationDate,
                  closingDate: incidentRecord.closingDate,
                  numberOfDays: incidentRecord.numberOfDays,
                  personName: incidentRecord.personName,
                  positionId: positionId,
                  position: position,
                  typeOfStaffId: typeOfStaffId,
                  typeOfStaff: typeOfStaff,
                  incidentAreaId: incidentAreaId,
                  siteId: incidentRecord.site.id,
                  site: incidentRecord.site.name,
                  eventDescription: incidentRecord.eventDescription,
                  imagesURL: incidentRecord.imagesURL,
                  images: incidentRecord.images,
                  rootCauseId: rootCauseId,
                  rootCause: rootCause,
                  consequencesSystemId: consequencesSystemId,
                  consequencesSystem: consequencesSystem,
                  headOfUN: incidentRecord.headOfUN,
                  employeeNumber: incidentRecord.employeeNumber,
                  dueDate: incidentRecord.dueDate,
                  responsible: incidentRecord.responsible,
                  rejectedReasonId: rejectedReasonId,
                  embbedingPromptResponse: incidentRecord.embbedingPromptResponse,
                })
              });

              var arrayGirdControlTowerPushEventId = arrayGirdControlTowerPush.find(f => f.eventId == eventId)

              console.log("arrayGirdControlTowerPushEventId", arrayGirdControlTowerPushEventId)

              var updateGridRowDto: UpdateGridRowDto = {
                columnName: "eventId",
                value: arrayGirdControlTowerPushEventId.eventId,
                newData: arrayGirdControlTowerPushEventId,
                action: action
              }
              this.gridService.UpdateRow(updateGridRowDto)
            }

            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )

    });
  }





  //-------------------------------------------------------------------------------------------------------












  private async getIncidentsByEventId(filters: IncidentByEventIdFilterDto): Promise<boolean> {

    this.modelIncident = { eventTypes: [], data: [] }
    this.arrayGirdControlTower = []

    return new Promise<boolean>((resolve, reject) => {

      this.controltowerservice.getIncidentsByEvent(filters).subscribe(
        {
          next: (incident: any) => {


            if (incident.data.length > 0) {


              var arrayGirdControlTowerPush = this.SetIncidentsInfo(incident)

              if (this.eventIdQueryParam != undefined && this.LoadByEventId == true) {
                var event = arrayGirdControlTowerPush.find(f => f.eventId == this.eventIdQueryParam)
                if (event !== undefined) {
                  this.cellClick(event)
                }

                this.filters.get('start').setValue(event.occurred, { emitEvent: false })

                let occurredDate = new Date(event.occurred);
                occurredDate.setDate(occurredDate.getDate() + 1);

                this.filters.get('end').setValue(occurredDate, { emitEvent: false })


                this.LoadByEventId = false


              }





              // let arrayGirdControlTowerPush: any[] = []

              // this.modelIncident = incident

              // let arrayEventsId: number[] = []



              // this.modelIncident.data.forEach(incidentRecord => {

              //   arrayEventsId.push(incidentRecord.eventId)

              //   const { id: typeOfOmissionId, name: typeOfOmission } = incidentRecord.typeOfOmission == undefined ? { id: null, name: "" } : incidentRecord.typeOfOmission
              //   const { id: categoryId, name: category } = incidentRecord.category == undefined ? { id: null, name: "" } : incidentRecord.category
              //   const { id: positionId, name: position } = incidentRecord.position == undefined ? { id: null, name: "" } : incidentRecord.position
              //   const { id: typeOfStaffId, name: typeOfStaff } = incidentRecord.typeOfStaff == undefined ? { id: null, name: "" } : incidentRecord.typeOfStaff
              //   const { id: incidentAreaId, name: incidentArea } = incidentRecord.incidentArea == undefined ? { id: null, name: "" } : incidentRecord.incidentArea
              //   const { id: rootCauseId, name: rootCause } = incidentRecord.rootCause == undefined ? { id: null, name: "" } : incidentRecord.rootCause
              //   const { id: consequencesSystemId, name: consequencesSystem } = incidentRecord.consequencesSystem == undefined ? { id: null, name: "" } : incidentRecord.consequencesSystem
              //   let { id: rejectedReasonId, name: rejectedReason } = incidentRecord.reasonRejection == undefined ? { id: null, name: "" } : incidentRecord.reasonRejection




              //   arrayGirdControlTowerPush.push({
              //     occurred: incidentRecord.occurred,
              //     incidentArea: incidentArea,
              //     incidentType: incidentRecord.incidentType.name,
              //     safetyItems: (incidentRecord.objectAttributes ?? []).filter(f => [32, 33, 34, 35, 58].includes(f.attributeTypeId)).map(m =>  m.value = { value: `${m.attributeTypeId}-${m.valueStr}` }),
              //     severity: incidentRecord.severity.name,
              //     incidentStatus: incidentRecord.incidentStatus.name,
              //     rejectedReason: rejectedReason,
              //     descripcion: incidentRecord.descripcion,
              //     monitoringAdvisor: incidentRecord.monitoringAdvisor,
              //     actionTaken: incidentRecord.actionTaken,
              //     eventId: incidentRecord.eventId,
              //     incidentTypeId: incidentRecord.incidentType.id,
              //     severityId: incidentRecord.severity.id,
              //     incidentStatusId: incidentRecord.incidentStatus.id,
              //     typeOfOmissionId: typeOfOmissionId,
              //     typeOfOmission: typeOfOmission,
              //     categoryId: categoryId,
              //     category: category,
              //     invoice: incidentRecord.invoice,
              //     address: incidentRecord.address,
              //     registrationDate: incidentRecord.registrationDate,
              //     closingDate: incidentRecord.closingDate,
              //     numberOfDays: incidentRecord.numberOfDays,
              //     personName: incidentRecord.personName,
              //     positionId: positionId,
              //     position: position,
              //     typeOfStaffId: typeOfStaffId,
              //     typeOfStaff: typeOfStaff,
              //     incidentAreaId: incidentAreaId,
              //     siteId: incidentRecord.site.id,
              //     site: incidentRecord.site.name,
              //     eventDescription: incidentRecord.eventDescription,
              //     imagesURL: incidentRecord.imagesURL,
              //     images: incidentRecord.images,
              //     rootCauseId: rootCauseId,
              //     rootCause: rootCause,
              //     consequencesSystemId: consequencesSystemId,
              //     consequencesSystem: consequencesSystem,
              //     headOfUN: incidentRecord.headOfUN,
              //     employeeNumber: incidentRecord.employeeNumber,
              //     dueDate: incidentRecord.dueDate,
              //     responsible: incidentRecord.responsible,
              //     rejectedReasonId: rejectedReasonId
              //   })
              // });

              // arrayGirdControlTowerPush.sort(function (a, b) {


              //   let aa = a.occurred;
              //   let bb = b.occurred;


              //   return aa > bb ? -1 : aa < bb ? 1 : 0
              //   return 0;
              // });

              // this.arrayGirdControlTower = arrayGirdControlTowerPush


              // if (this.eventIdQueryParam != undefined && this.LoadByEventId == true) {
              //   var event = arrayGirdControlTowerPush.find(f => f.eventId == this.eventIdQueryParam)
              //   if (event !== undefined) {
              //     this.cellClick(event)
              //   }

              //   this.filters.get('start').setValue(event.occurred, { emitEvent: false })

              //   let occurredDate = new Date(event.occurred);
              //   occurredDate.setDate(occurredDate.getDate() + 1);

              //   this.filters.get('end').setValue(occurredDate, { emitEvent: false })


              //   this.LoadByEventId = false

              // }
            } else {
              this.getIncidendsByFilters()
            }

            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )

    });
  }

  private async getIncidentsTypes(today: any): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {

      var sites = localStorage.getItem('site')

      var sitesIds = []
      sites.split(',').forEach(site => {
        sitesIds.push(Number.parseInt(site))
      });


      var request = {
        LocaleCode: this.lang,
        SitesId: sitesIds,
        MinDate: today
      }

      this.controltowerservice.getUsedIncidentsTypes(request).subscribe(
        {
          next: (incidentype: any) => {

            this.arrayIncidentsTypes = incidentype;

            setTimeout(() => {
              console.log("setTioout")
              this.setDefaultIncidentTypes();
            }, 3000);

            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }



  private async getSites(): Promise<boolean> {

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getSites().subscribe(
        {
          next: (sites: ISitesResponse) => {

            this.arraySites = sites.result
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  private async getncidentStatus(): Promise<boolean> {

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getIncidentsStatus(this.lang).subscribe(
        {
          next: (status: any) => {
            this.arrayIncidentStatus = status
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  toggleAllSelection(matSelect: MatSelect) {
    const isSelected: boolean = matSelect.options
      .filter((item: MatOption) => item.value === 0)
      .map((item: MatOption) => item.selected)
    [0];

    if (isSelected) {
      matSelect.options.forEach((item: MatOption) => item.select());
    } else {
      matSelect.options.forEach((item: MatOption) => item.deselect());
    }
  }

  public hideModal(modalData: closeModalEventData) {
    this.showModal(modalData.openModal)
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  public showModal(show: boolean) {
    this._showModal = show;
    if (show == true) {
      this.scrollToTop()
    }

    this.notificationsService.IsModalOpen(this._showModal)

    this.isModalOpen = show

    this.drawer.toggle(show)
  }

  public backdropClick() {
    this.showModal(false)
  }

  async getConfigurationReport(_site: string, type: string, dashboardTypeId: string, businessUnitId: string): Promise<any> {
    return this.sharedService.getPBITokenInfo(this._site, type, dashboardTypeId, businessUnitId).toPromise()
  }

  changeFormat(format: string) {
    this.currentFormat = format
  }

  async ReloadDashboard() {
    const pages = await this.report.getPages()
    const page = pages.find(p => p.isActive)
    const visuals = await page.getVisuals()
    const filters = await visuals.filter(t => t.title !== undefined && t.type === 'slicer')
    await this.setFilters(filters)
    this.descargado = true
    this.sharedService.getExportStream(this._site, '4', this.currentFormat, this.dashboardTypeId, this.businessUnitId, this.filtersGeneralDashboardModel, SourcePowerBIEnum.PED).subscribe((response) => {
      this.showFile(response)
      this.descargado = false
    })
  }

  async setFilters(filters: any): Promise<void> {
    const year = await filters.filter(f => f.title === FilterGD.Year)
    const month = await filters.filter(f => f.title === FilterGD.Month)
    const day = await filters.filter(f => f.title === FilterGD.Day)
    const filteryear = await year[0].getSlicerState()
    const filtermonth = await month[0].getSlicerState()
    const filterday = await day[0].getSlicerState()

    this.filtersGeneralDashboardModel = {
      filters: [
        {
          target: filteryear.filters[0]?.target,
          operator: filteryear.filters[0]?.operator,
          values: filteryear.filters[0]?.values
        },
        {
          target: filtermonth.filters[0]?.target,
          operator: filtermonth.filters[0]?.operator,
          values: filtermonth.filters[0]?.values
        },
        {
          target: filterday.filters[0]?.target,
          operator: filterday.filters[0]?.operator,
          values: filterday.filters[0]?.values
        }
      ]
    }
    this.filtersGeneralDashboardModel.filters = this.filtersGeneralDashboardModel.filters.filter(f => f.values != null && f.target != null)
  }

  showFile(blob: Blob) {
    let newBlob = blob
    const data = window.URL.createObjectURL(newBlob);
    let link = document.createElement('a');
    link.href = data;
    switch (this.currentFormat) {
      case '1':
        link.download = "HealthSafetyControlTower.pdf";
        break;
      case '2':
        link.download = "HealthSafetyControlTower.pptx";
        break;
    }
    link.click();
    setTimeout(function () {
      window.URL.revokeObjectURL(data);
    }, 100);
  }

  changeSize(mql) {
    mql.matches ?
      this.sharedService.getPBITokenInfo(this._site, this.type, this.dashboardTypeId, this.businessUnitId)
        .subscribe((response) => {
          let data = response.data
          this.showReport(data);
        }) :
      this.sharedService.getPBITokenInfo(this._site, this.type, this.dashboardTypeId, this.businessUnitId)
        .subscribe((response) => {
          let data = response.data
          this.showReport2(data);
        })
  }

  showReport2(data) {
    let embedUrl = data.embedReport[0].embedUrl
    let embedReportId = data.embedReport[0].reportId
    let config = {
      type: 'report',
      tokenType: 1,
      accessToken: data.embedToken.token,
      embedUrl: embedUrl,
      id: embedReportId,
      settings: {
        layoutType: 2,
        panes: {
          filters: {
            visible: false
          },
          pageNavigation: {
            visible: false
          }
        }
      }
    };
    let reportContainer = document.getElementById('healthsafetycontroltower')
    let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
    let report = powerbi.embed(reportContainer, config);
    report.off("loaded");
    report.on("loaded", () => {
    });
    report.on("error", (e) => {
    });
  }

  async showReport(data: Data) {
    let models = pbi.models
    let permissions = models.Permissions.Read
    let loadedResolve, reportLoaded = new Promise((res, rej) => { loadedResolve = res })
    let renderedResolve, reportRendered = new Promise((res, rej) => { renderedResolve = res })
    let embedUrl = data.embedReport[0].embedUrl
    let embedReportId = data.embedReport[0].reportId
    let reportContainer = <HTMLElement>document.getElementById('healthsafetycontroltower')
    let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
    powerbi.reset(reportContainer)
    let config = {
      type: 'report',
      tokenType: models.TokenType.Embed,
      accessToken: data.embedToken.token,
      embedUrl: embedUrl,
      id: embedReportId,
      permissions: permissions,
      viewMode: models.ViewMode.View,
      settings: {
        layoutType: models.LayoutType.Master,
        bars: {
          actionBar: { visible: false }
        },
        panes: {
          filters: { visible: false },
          pageNavigation: { visible: false },
          bookmarks: { visible: false }
        }
      }
    }
    try {
      this.report = <pbi.Report>powerbi.embed(reportContainer, config) as pbi.Visual
      this.report.off("loaded")
      this.report.on("loaded", () => {
        const filter = {
          $schema: environment.urlPowerBI,
          target: {
            table: "BIG_TABLE_EFFICIENCY",
            column: "ID_FACILITY"
          },
          operator: "In",
          values: [localStorage.getItem('site')],
          filterType: 1,
          requireSingleSelection: true
        }
        this.report.setFilters([filter]).then(res => {
          this.report.getFilters().then(filters => {
          });
        }).catch((error: any) => {
          console.error(error);
        });
        loadedResolve()
        this.report.off("loaded")
      })
      this.report.off("error")
      this.report.on("error", (e) => {

        this.changeSize(this.desktopView)
      })
      this.report.off("rendered")
      this.report.on("rendered", function () {
        renderedResolve()
      })
    } catch (error) {

    }

    await reportLoaded

    await reportRendered
  }

  public async cellClick(obj: any) {
    this.incidentRecordData = undefined
    this.incidentRecordData = obj
    localStorage.setItem('rowSelectEvent', JSON.stringify(obj))
    this.showModal(true)
  }

  public cardClick(filter: any) {

    if (this.activeFilter == filter.id) {
      this.activeFilter = -1
    } else {
      this.activeFilter = filter.id
    }

    if (filter.relatedEventTypes == null) {
      this.filterGridFromCardSelected(this.activeFilter)
    } else {

      if (this.activeFilter == -1) {
        const gridFilter: GridFilter = {
          importance: 1,
          column: "incidentTypeId",
          filter_one: undefined,
          isFilterDates: false,
          isExternalFilter: true
        }

        this.gFilter = [gridFilter]
      } else {

        var relatedEventTypes = filter.relatedEventTypes.map(m => {
          const gridFilter: GridFilter = {
            importance: 1,
            column: "incidentTypeId",
            filter_one: m == undefined ? undefined : m.toString(),
            isFilterDates: false,
            isExternalFilter: true
          }

          return gridFilter
        });

        this.gFilter = relatedEventTypes
      }
    }
  }

  private filterGridFromCardSelected(activeFilter: number) {
    let filter: string = undefined

    if (activeFilter >= 0) {
      filter = activeFilter.toString()
    }

    const gridFilter: GridFilter = {
      importance: 1,
      column: "incidentTypeId",
      filter_one: filter,
      isFilterDates: false,
      isExternalFilter: true
    }

    this.gFilter = [gridFilter]

  }
}
